import ProductAdminLayout from './ProductAdminLayout';
export default ProductAdminLayout;
